package com.bulut.mecitogullari.ui.screens.projects

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.bulut.mecitogullari.data.model.Project
import com.bulut.mecitogullari.data.model.TransactionType
import com.bulut.mecitogullari.data.model.UnitStatus
import com.bulut.mecitogullari.data.repository.ProjectRepository
import com.bulut.mecitogullari.data.repository.TransactionRepository
import com.bulut.mecitogullari.data.repository.UnitRepository
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.stateIn

data class ProjectCardData(
    val project: Project,
    val soldUnits: Int,
    val totalUnits: Int,
    val totalExpense: Double,
    val totalIncome: Double,
)

data class ProjectsUiState(
    val projects: List<ProjectCardData> = emptyList(),
)

class ProjectsViewModel(
    projectRepository: ProjectRepository,
    unitRepository: UnitRepository,
    transactionRepository: TransactionRepository,
) : ViewModel() {

    val uiState: StateFlow<ProjectsUiState> = combine(
        projectRepository.projects,
        unitRepository.units,
        transactionRepository.transactions,
    ) { projects, units, transactions ->
        ProjectsUiState(
            projects = projects.map { project ->
                val projectUnits = units.filter { it.projectId == project.id }
                val projectTxs = transactions.filter { it.projectId == project.id }
                ProjectCardData(
                    project = project,
                    soldUnits = projectUnits.count { it.status == UnitStatus.SOLD },
                    totalUnits = projectUnits.size,
                    totalExpense = projectTxs.filter { it.type == TransactionType.EXPENSE }.sumOf { it.amount },
                    totalIncome = projectTxs.filter { it.type == TransactionType.INCOME }.sumOf { it.amount },
                )
            }.sortedByDescending { it.project.createdAtEpochMillis },
        )
    }.stateIn(
        scope = viewModelScope,
        started = SharingStarted.WhileSubscribed(5_000),
        initialValue = ProjectsUiState(),
    )
}
